import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Header.css';
import logo from '../assets/Branding/B&M_Logo/logo_in_white.png';
import phoneIcon from '../assets/Branding/B&M_icons/phone_call.png';
import emailIcon from '../assets/Branding/B&M_icons/email.png';

const Header = () => {
  return (
    <header className="header">
      <div className="header-content">
        <div className="logo-container">
          <Link to="/">
            <img src={logo} alt="Bubble & Maple" className="logo" />
          </Link>
        </div>
        <div className="contact-info">
          <a href="tel:+14404143624" className="contact-item">
            <img src={phoneIcon} alt="" className="contact-icon" />
            <div className="contact-text">
              <span className="contact-label">CALL NOW</span>
              <span className="contact-value">440-414-3624</span>
            </div>
          </a>
          <a href="mailto:support@bubbleandmaple.com" className="contact-item">
            <img src={emailIcon} alt="" className="contact-icon" />
            <div className="contact-text">
              <span className="contact-label">EMAIL</span>
              <span className="contact-value">support@bubbleandmaple.com</span>
            </div>
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header; 